/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import _ from 'lodash';

export default {
    getCardAriaLabel() {
        const options = _.last(arguments);
        const cardTitle = options.scope.attr('title');
        return cardTitle;
    },
    getCardLink() {
        const options = _.last(arguments);
        const inWebView = _.get(window.globalSettings, 'inWebView') === true;
        const videoPageUrl = _.get(window.globalSettings, 'pagePaths.video');
        const cardType = options.scope.attr('type');
        const cardTitle = encodeURIComponent(options.scope.attr('title'));
        const videoId = options.scope.attr('video.identifier');
        const urlHash = options.scope.attr('urlHash');
        const fromTimeline = options.scope.attr('fromTimeline');

        if (cardType === 'videoCard' && videoId) {
            return `${videoPageUrl}#brightcoveId=${videoId}&pageTitle=${cardTitle}&playlist=unknown`;
        }

        let contentPath = options.scope.attr('contentPath');
        let contentUrl = options.scope.attr('contentUrl');
        let cardPath;
        let url;

        if (!contentPath && !contentUrl) {
            return '';
        }

        if (contentPath) {
            contentPath = contentPath.replace(/(\.mobile)?\.html$/, '');
        }

        if (contentUrl) {
            contentUrl = contentUrl.replace(/(\.mobile)?\.html$/, '');
        }

        cardPath = contentPath ? contentPath : contentUrl;

        if (inWebView) {
            url = `${cardPath}.mobile.html`;
        } else {
            url = `${cardPath}.html`;
        }

        if (!!urlHash && !!fromTimeline) {
            url = url + '#' + urlHash + '&returnable';
        } else if (!!fromTimeline) {
            url = url + '#returnable';
        }

        return url;
    },
    getShareUrl() {
        const options = _.last(arguments);
        return options.scope.attr('shareUrl');
    }
};
